import { isDefined } from '@sgme/fp';
import { IntlKey } from 'locales';
import { TradeWay } from 'models/TradeWay';
import { ReactNode } from 'react';
import { connect } from 'react-redux';
import { logAnalytics } from 'shared/middlewares/analytics/logger';
import { dynamicQuoteTradeCancelledThunk } from 'state/dynamic/dynamicForm.thunks';
import { getFormInfos, getFormQuoteId, getSidePanelTradeWayOrDefault } from 'state/selectors';
import { getTradeInfosByWorkspaceTab } from 'state/selectors/common/temp';
import type { ThunkDispatch } from 'state/state.common';
import type { AppState } from 'state/state.model';
import { staticQuoteTradeCancelledThunk } from 'state/static/staticForm.thunks';
import { confirmedIsTrading } from 'state/uiPanelState/tradeConfirmation/tradeConfirm.action';
import type { QuoteWorkspaceType } from 'state/workspaces/model';

export interface OwnProps {
  tabId: string;
  workspaceType: QuoteWorkspaceType;

  className?: string;
  id: string;

  tradeLabelKey: IntlKey;
  e2e: string;
  children?: ReactNode;
}

export interface StateProps {
  quoteId: string;

  canTrade: boolean;
  tradeWay: TradeWay;
}

export interface DispatchProps {
  onCancel(): void;
  onTrade(quoteId: string): void;
}

export type TradeInitButtonProps = StateProps & DispatchProps & OwnProps;

const mapStateToProps = (state: AppState, { tabId, workspaceType }: OwnProps): StateProps => {
  const { tradeAuthStatus } = getTradeInfosByWorkspaceTab(state, workspaceType, tabId);
  const quoteInfos = getFormInfos(state, workspaceType, tabId);
  const validationErrors = quoteInfos?.validationErrors;

  const hasDealSplitWarningOrError = isDefined(validationErrors?.find(error => error.fields?.includes('DealSplit')));

  return {
    quoteId: getFormQuoteId(state, workspaceType, tabId)!,
    canTrade: tradeAuthStatus === 'Granted' && !hasDealSplitWarningOrError,
    tradeWay: getSidePanelTradeWayOrDefault(state, tabId),
  };
};

const mapDispatchToProps = (dispatch: ThunkDispatch, { tabId, workspaceType }: OwnProps): DispatchProps => ({
  onCancel() {
    if (workspaceType === 'static') {
      logAnalytics.trackEvent('Primary market static', 'Cancel tradable quote');
      dispatch(staticQuoteTradeCancelledThunk(tabId));
    } else {
      logAnalytics.trackEvent('Primary market dynamic', 'Cancel tradable quote');
      dispatch(dynamicQuoteTradeCancelledThunk(tabId));
    }
  },
  onTrade(quoteId: string) {
    if (workspaceType === 'static') {
      logAnalytics.trackEvent('Primary market static', 'Request for trade');
      dispatch(confirmedIsTrading(quoteId));
    } else {
      logAnalytics.trackEvent('Primary market dynamic', 'Request for trade');
      dispatch(confirmedIsTrading(quoteId));
    }
  },
});

export const connectInitiatingTradeButtons = connect(mapStateToProps, mapDispatchToProps);
